import React from 'react';
import { toast } from 'react-toastify';

import fileData from '../../../interface/props/table/files';
import Images from '../../../assets/images/images';

import styles from './FileType.module.css';
import capitalizeFirstLetter from '../../../utils/firstLetterCapital';

type Props = {
  document: fileData;
};

const FileType: React.FC<Props> = ({ document }) => {
  const fileType = document.fileType;
  const fileIcon =
    fileType === 'notes'
      ? Images.doc
      : fileType === 'video'
      ? Images.video
      : Images.demo;

  const copyTypeId = () => {
    const value = `${fileType}_${document._id}`;
    navigator.clipboard.writeText(value);
    toast.success(`Copied: ${value}`);
  };

  return (
    <div className={styles['file-type-container']}>
      <button
        type="button"
        className={styles['file-type-icon-button']}
        onClick={copyTypeId}
        title={`Copy ${fileType}_${document._id}`}
        aria-label={`Copy ${fileType}_${document._id}`}
      >
        <img src={fileIcon} alt={fileType} />
      </button>
      <span>{capitalizeFirstLetter(fileType)}</span>
    </div>
  );
};

export default FileType;
